import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';

import * as moment from 'moment';
import { LoaderService } from '../../services/loader.service';
import { LoaderState } from '../loader/loader';

@Component({
  selector: 'rm-dynamic-table',
  templateUrl: './dynamic-table.component.html',
  styleUrls: ['./dynamic-table.component.css'],
})
export class DynamicTableComponent implements OnInit, OnDestroy {
  selection = new SelectionModel<string>(true, []);

  @Input('data')
  public data: Array<any>;

  @Input('columns')
  columns: any;

  @Input('sortBy')
  public sortBy: string;

  @Input('sortOrder')
  public sortOrder: 'asc' | 'desc';

  @Input('pagination')
  pagination: boolean = true;

  @Input('totalCount')
  totalCount: any;

  @Input()
  rowStyleFn: any;

  @Input()
  rowTipRenderFn: any;

  @Input() moveToFirstPage: boolean = false;

  @Output('rowClicked')
  public rowClicked = new EventEmitter();

  @Output('actionClicked')
  public actionClicked = new EventEmitter();

  @Output('actionableClicked')
  public actionableClicked = new EventEmitter();

  @Output('pageChanged')
  public pageChanged = new EventEmitter();

  @Output('sortChanged')
  public sortChanged = new EventEmitter<string>();

  subscriptions: any[] = [];
  loaded: boolean = true;

  displayedColumns: any;
  dataSource: MatTableDataSource<any>;

  //Pagination
  length: number = null;
  pageSize: number = 5;
  pageSizeOptions: number[] = [5, 10, 25, 50, 100];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  //Sorting
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(private loaderService: LoaderService) {}

  ngOnInit() {}

  ngOnDestroy() {}

  onSort(sort: { active: string; direction: 'asc' | 'desc' }) {
    console.log('DynamicTableComponent: matSortChange event fired.', sort);
    this.sortChanged.emit(sort.active);
  }

  getDataValue(column, element, dataField) {
    let field = dataField;
    if (field.includes('.')) {
      let fieldArr = field.split('.');
      let value = element;
      fieldArr.forEach((item) => {
        value = value[item];
      });
      var retVal = '';
      switch (column.type) {
        case 'boolean':
          retVal = value ? 'Yes' : 'No'; //default formatter, for now
          break;
        case 'time':
          var fmt = column.format;
          retVal = moment(value).format(fmt);
          break;
        case 'date':
          var fmt = column.format;
          var val = value;
          retVal = val ? moment(value).format(fmt) : val;
          break;
        case 'unknown':
          retVal = value == 0 ? 'UNKNOWN' : value;
          break;
        default:
          retVal = value;
      }

      return retVal;
    } else {
      var retVal = '';
      switch (column.type) {
        case 'boolean':
          retVal = element[column.name] ? 'Yes' : 'No'; //default formatter, for now
          break;
        case 'time':
          var fmt = column.format;
          retVal = moment(element[column.name]).format(fmt);
          break;
        case 'date':
          var fmt = column.format;
          var val = element[column.name];
          retVal = val ? moment(element[column.name]).format(fmt) : val;
          break;
        default:
          retVal = element[field];
      }
      return retVal;
    }
  }

  ngOnChanges(changes) {
    console.log('changes', changes);
    if (changes.data && changes.data.previousValue) {
      this.loaded = true;
    }

    if (
      changes.moveToFirstPage &&
      changes.moveToFirstPage.currentValue === true
    ) {
      this.paginator.pageIndex = 0;
    }
    this.reConfigureGrid();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.dataSource.paginator = this.paginator;
    }, 2000);
    this.dataSource.sort = this.sort;
  }

  reConfigureGrid() {
    this.dataSource = new MatTableDataSource(this.data);
    if (this.columns && this.columns.length > 0) {
      this.displayedColumns = this.columns.map((col) => col.name);
    } else {
      this.displayedColumns = [];
    }
    this.length = this.totalCount;
  }

  onRowClick(rowIndex, record) {
    console.log('onRowClick:', arguments);
    this.rowClicked.emit({ rowIndex: rowIndex, record: record });
  }

  onActionClick(actionName, record, idx) {
    this.actionClicked.emit({
      actionName: actionName,
      record: record,
      rowIndex: idx,
    });
  }

  onActionableClick(name, record, idx) {
    this.actionableClicked.emit({
      actionName: name,
      record: record,
      rowIndex: idx,
    });
  }

  onPageChange(pageEvnt) {
    this.pageChanged.emit(pageEvnt);
  }
}
